import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import SecondaryButton from '../../components/SecondaryButton/SecondaryButton';
import { encodePathSegment, requestWithApiFallback } from '../../utils/apiRequest';
import style from './OnboardingFlow.module.css';

const API_URL = process.env.REACT_APP_API_URL;

const RoutineRouteResolverPage = () => {
	const { routineId } = useParams();
	const navigate = useNavigate();
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		const resolveRoutineRoute = async () => {
			try {
				const response = await requestWithApiFallback(API_URL, (base) => axios.get(
					`${base}/onboarding/routine-route/${encodePathSegment(routineId)}`
				));

				const resolvedRoute = response?.data?.route;
				if (!resolvedRoute) {
					throw new Error('Route not found');
				}
				navigate(resolvedRoute, { replace: true });
			} catch (error) {
				console.error('Failed to resolve routine route by id:', error);
				setErrorMessage('We could not locate this routine.');
			}
		};

		if (routineId) {
			resolveRoutineRoute();
		} else {
			setErrorMessage('Missing routine id.');
		}
	}, [navigate, routineId]);

	if (!errorMessage) {
		return (
			<div className={style.LoadingWrap}>
				<p>Opening your routine...</p>
			</div>
		);
	}

	return (
		<div className={style.OnboardingPage}>
			<SEO title="Routine unavailable" description="This routine link is unavailable." noIndex />
			<div className={style.OnboardingCard}>
				<p className={style.MutedText}>{errorMessage}</p>
				<SecondaryButton text="Back home" click={() => navigate('/')} width="100%" />
			</div>
		</div>
	);
};

export default RoutineRouteResolverPage;
